export default class ProductFieldsLoader {
	currentVariationSelector = 'input[type="hidden"][name^="variation_id"]';
	currentProductSelector = 'input[type="hidden"][name="product_id"]';

	beforeAddToCartFieldsSelector = '.fpf-fields.before-add-to-cart';
	afterAddToCartFieldsSelector = '.fpf-fields.after-add-to-cart';

	constructor() {
		jQuery(document.body).on('found_variation', (event, variation) => {
			this.getFields(variation.variation_id);
		});
		jQuery(document.body).on('reset_data', () => {
			const variable_product_id = jQuery(
				this.currentProductSelector
			).val();
			this.getFields(variable_product_id);
		});
	}

	getFields(productId) {
		const fieldsData = jQuery('.fpf-field input')
			.serializeArray()
			.reduce((acc, field) => {
				acc[field.name] = field.value;
				return acc;
			}, {});
		const $fpfProductId = jQuery(
			'input[type="hidden"][name="_fpf_product_id"]'
		);
		const $beforeAddToCartFields = jQuery(
			this.beforeAddToCartFieldsSelector
		);
		const $afterAddToCartFields = jQuery(this.afterAddToCartFieldsSelector);

		jQuery.ajax({
			type: 'POST',
			url: fpf_pro_front.ajax_url,
			data: {
				action: 'fpf_fields',
				product_id: productId,
				nonce: fpf_pro_front.nonce,
				...fieldsData,
			},
			success: (response) => {
				if (response.success === true) {
					$beforeAddToCartFields.replaceWith(
						response.data.html_before
					);
					$afterAddToCartFields.replaceWith(response.data.html_after);
					$fpfProductId.val(response.data.product_id);

					fpf_product.fpf_product_price =
						response.data.fpf_product_price;
					fpf_product.fpf_fields = response.data.fpf_fields;
					fpf_product.fields_rules = response.data.fields_rules;

					jQuery(document).trigger('fpf_fields_ready');
				} else {
					console.error('Error fetching FPF fields:', response.data);
				}
			},
			error: (xhr, status, error) => {
				console.error('Error fetching FPF fields:', error);
			},
		});
	}
}
